// extracted by mini-css-extract-plugin
module.exports = {"rightContentImage":"classes_rightContentImage__c0xtw","cartTitle":"classes_cartTitle__21H4d"};